export default function capitalizeString(string) {
  return string.charAt(0).toUpperCase() + string.substr(1);
}
